export const ALLIANZ_BLUE = '#003781';
